import React from 'react';
import PropTypes from 'prop-types';

const Svg = ({ className, icon, ...rest }) => (
  <svg className={className} {...rest}>
    <use xlinkHref={`#${icon}`} xmlnsXlink="http://www.w3.org/1999/xlink" />
  </svg>
);

Svg.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
};

Svg.defaultProps = {
  className: '',
  icon: '',
};

export default Svg;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Svg.js